document.addEventListener('DOMContentLoaded', () => {
  toggleHeaderBg()

  window.addEventListener('scroll', () => {
    toggleHeaderBg()
  })
})

const toggleHeaderBg = () => {
  const scroll = window.scrollY || window.pageYOffset
    const headerEl = document.querySelector('header')
    if (scroll > 0) {
      headerEl.classList.add('solid')
    } else if (scroll === 0) {
      headerEl.classList.remove('solid')
    }
}

document.querySelectorAll('#mobile-primary-menu > li.menu-item-has-children').forEach(function(elem) {
  elem.addEventListener('click', function(e) {
    this.classList.toggle('open'); 
  });
});